import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Home } from 'lucide-react';

const NotFoundPage = () => {
    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="flex justify-center">
                    <AlertTriangle className="h-16 w-16 text-yellow-600" />
                </div>
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Page Not Found</h2>
                <p className="mt-2 text-center text-sm text-gray-600">
                    The page you're looking for doesn't exist or has been moved
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                        <div className="flex">
                            <div className="ml-3">
                                <p className="text-sm text-yellow-700">
                                    The URL you entered may be incorrect or the page may have been removed.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        <p className="text-gray-500 mb-6">
                            Error 404: Page not found
                        </p>

                        <Link
                            to="/"
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            <Home className="h-4 w-4 mr-2" />
                            Back to Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;